import React from "react";

const CalendarBlank = () => {
	return (
		<>
			<svg
				width="27"
				height="23"
				viewBox="0 0 27 23"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<g id="CalendarBlank">
					<path
						id="Vector"
						d="M21.6571 3.59375H4.99706C4.53701 3.59375 4.16406 3.91555 4.16406 4.3125V18.6875C4.16406 19.0845 4.53701 19.4062 4.99706 19.4062H21.6571C22.1172 19.4062 22.4901 19.0845 22.4901 18.6875V4.3125C22.4901 3.91555 22.1172 3.59375 21.6571 3.59375Z"
						stroke="currentColor"
						strokeWidth="1.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						id="Vector_2"
						d="M18.3262 2.15625V5.03125"
						stroke="currentColor"
						strokeWidth="1.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						id="Vector_3"
						d="M8.33008 2.15625V5.03125"
						stroke="currentColor"
						strokeWidth="1.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
					<path
						id="Vector_4"
						d="M4.16406 7.90625H22.4901"
						stroke="currentColor"
						strokeWidth="1.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</g>
			</svg>
		</>
	);
};
export default CalendarBlank;
